export default __webpack_public_path__ + "static/media/auth.e83cc392.svg";